exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-ffde90b6]:before,\n.wrapper[data-v-ffde90b6]:after {\n  display: table;\n  content: \" \";\n}\n.wrapper[data-v-ffde90b6]:after {\n  clear: both;\n}\n.wrapper[data-v-ffde90b6] {\n  display: table;\n  overflow-x: hidden;\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n}\n.right-aside[data-v-ffde90b6],\n.left-aside[data-v-ffde90b6] {\n  padding: 0;\n  display: table-cell;\n  vertical-align: top;\n}\n.right-aside[data-v-ffde90b6] {\n  background-color: #ebf2f6 !important;\n}\n@media (max-width: 992px) {\n.wrapper > .right-aside[data-v-ffde90b6] {\n    width: 100vw;\n    min-width: 100vw;\n}\n}\n", ""]);

// exports
